import script from "./notifications-center.vue?vue&type=script&setup=true&lang=js"
export * from "./notifications-center.vue?vue&type=script&setup=true&lang=js"

import "./notifications-center.vue?vue&type=style&index=0&id=6a5655ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a5655ec"]])

export default __exports__